<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <!-- <keep-alive> -->
      <router-view></router-view>
      <!-- </keep-alive> -->
    </transition>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
  }
}
</script>

<style>
#app {
  max-width: 1920px;
  margin: 0 auto;
}
/* 整个滚动条 */
::-webkit-scrollbar {
  width: 5px;
}
/* 滚动条上的滚动滑块 */
::-webkit-scrollbar-thumb {
  background-color: #eee;
  border-radius: 32px;
}
/* 滚动条轨道 */
::-webkit-scrollbar-track {
  border-radius: 32px;
}
pre {
  white-space: pre-wrap; /* 保留空格和换行，但自动换行 */
  word-wrap: break-word; /* 确保长单词也能换行 */
  overflow-x: auto; /* 当内容超出容器宽度时显示滚动条 */
}
.el-collapse {
  border: none !important;
}
.leapin-text-center {
  text-align: center;
}
.leapin-text-left {
  text-align: left;
}
.leapin-text-right {
  text-align: right;
}
.leapin-mr-20 {
  margin-right: 20px;
}
.leapin-felx-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.leapin-w-100 {
  width: 100%;
}
.leapin-h-100 {
  height: 100%;
}
.leapin-bg-black {
  background-color: #000;
}
.pointer {
  cursor: pointer;
}
.leapin-fs-yellow {
  color: #ff8a64;
}
.leapin-fs-14 {
  font-size: 14px;
}
.leapin-fs-18 {
  font-size: 18px;
}
.leapin-ml-2 {
  margin-left: 2px;
}
.leapin-ml-6 {
  margin-left: 6px;
}
.leapin-ml-16 {
  margin-left: 16px;
}
.leapin-mr-4 {
  margin-right: 4px;
}
.leapin-mr-6 {
  margin-right: 6px;
}
.leapin-mr-16 {
  margin-right: 16px;
}
.leapin-mr-20 {
  margin-right: 20px;
}
.leapin-mr-25 {
  margin-right: 25px;
}
.leapin-mr-8 {
  margin-right: 8px;
}
.leapin-mb-6 {
  margin-bottom: 6px;
}
.leapin-mt-15 {
  margin-top: 15px;
}
.leapin-mt-20 {
  margin-top: 20px;
}
.leapin-mt-25 {
  margin-top: 25px;
}
.leapin-mt-30 {
  margin-top: 30px;
}
.leapin-mt-38 {
  margin-top: 38px !important;
}
.leapin-mb-12 {
  margin-bottom: 12px;
}
.leapin-mb-20 {
  margin-bottom: 20px;
}
.leapin-f-r {
  float: right;
}
.lepain-object-cover {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.leapin-felx-center-12 {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0 12px;
}
.leapin-felx-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.leapin-felx-start-12 {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}
.leapin-long-button {
  display: flex;
    width: 388px;
    height: 40px;
    padding: 5px 16px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 100px;
    background: #6E62E5;
    margin: 0 auto;
    color: #FFF;
    font-family: "PingFang SC";
    font-size: 14px;
    font-weight: 400;
    margin-top: 10px;
}
.leapin-long-button:hover {
  cursor: pointer;
  opacity: 0.8;
}
.leapin-short-defalut-button {
  color: #4E5969;
  display: flex;
  width: 120px;
  height: 40px;
  padding: 5px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 100px;
  background: #F2F3F5;
}
.leapin-short-defalut-button:hover {
  cursor: pointer;
  opacity: 0.8;
}
.leapin-short-primary-button {
  color: #fff;
  display: flex;
  width: 120px;
  height: 40px;
  padding: 5px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 100px;
  background: #6E62E5;
}
.leapin-short-primary-button:hover {
  cursor: pointer;
  opacity: 0.8;
}
.el-button--primary {
  background: #6E62E5 !important;
  border-color: #6E62E5 !important;
  color: #fff;
}
.el-button--primary.is-disabled, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
  background: #C5C0F5 !important;
  border-color: #C5C0F5 !important;
  color: #fff;
}

.el-button {
  min-width: 120px;
}

.leapin-tags {
  cursor: pointer;
  width: fit-content;
  padding: 8px 12px;
  border-radius: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: "PingFang SC";
  font-size: 14px;
  font-weight: 400;
}
.leapin-purple {
  color: #6E62E5;
  background: rgba(110, 98, 229, 0.15);
}
.leapin-blue {
  color: #1180FF;
  background: rgba(17, 128, 255, 0.15);
}
.leapin-gary {
  color: #666;
  background: rgba(156, 156, 156, 0.15);
}
.leapin-light-huge-button {
  cursor: pointer;
  display: flex;
  height: 40px;
  padding: 0px 12px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 100px;
  border: 1px solid #6E62E5;
  color: #6E62E5;
  background: #fff;
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 157.143% */
  /* text-transform: uppercase; */
  letter-spacing: 0.5px;
}
.leapin-primary-huge-button {
  cursor: pointer;
  display: flex;
  height: 40px;
  width: fit-content;
  padding: 0px 12px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  background: #6E62E5;
  border-radius: 100px;
  color: #fff;
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 157.143% */
  letter-spacing: 0.5px;
}
.leapin-air-title {
  color: #000;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 14px;
  /* font-family: "PingFang SC"; */
  display: flex;
  align-items: center;
  justify-content: flex-start;
  letter-spacing: 0.5px;
}
.leapin-air-title img {
  width: 18px;
  height: 18px;
  margin-right: 8px;
}
.leapin-ai-button {
  display: flex;
  padding: 10px 14px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: linear-gradient(90deg, #46C8FF 0%, #6E62E5 100%);
  color: var(--text-white, #FFF);
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  cursor: pointer;
}
.el-drawer__header {
  font-size: 20px !important;
  font-weight: 500 !important;
}
.el-tag .el-tag__close {
  color: #6E62E5 !important;
}
.el-tag .el-tag__close:hover {
  background: rgba(110, 98, 229, 0.15) !important;
}
.leapin-logo-avatar {
  background: #6E62E5;
  color: #fff;
  border-radius: 100px;
}
.leapin-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.el-cascader-menu {
  max-height: 300px; /* 设置你想要的高度 */
  overflow-y: auto; /* 如果内容超出，显示滚动条 */
}
.leapin-ob-small {
  height: 24px !important;
  width: fit-content !important;
}
</style>
